var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYtMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z",
    fill: "#40B0BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 18.8182C45.45 18.8182 53.1818 26.5091 53.1818 36C53.1818 45.4909 45.4909 53.1818 36 53.1818C26.5091 53.1818 18.8182 45.4909 18.8182 36C18.8182 26.5091 26.55 18.8182 36 18.8182ZM36 17.1818C25.6091 17.1818 17.1818 25.6091 17.1818 36C17.1818 46.3909 25.6091 54.8182 36 54.8182C46.3909 54.8182 54.8182 46.3909 54.8182 36C54.8182 25.6091 46.3909 17.1818 36 17.1818Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4546 45.4091L45.4091 35.5909L29.4546 26.5909V45.4091Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtMusic);
export default __webpack_public_path__ + "static/media/yt_music.8428edc7024dae39791160ea01bcc745.svg";
export { ForwardRef as ReactComponent };